import { useI18n as useVueI18n } from 'vue-i18n';

let i18nInstance = null;

export function setI18nInstance(instance) {
  i18nInstance = instance;
}

const bindGlobalI18n = (globalI18n) => ({
  locale: globalI18n.locale,
  t: globalI18n.t.bind(globalI18n),
  tc: (globalI18n.tc || globalI18n.t).bind(globalI18n),
  d: globalI18n.d.bind(globalI18n),
  te: globalI18n.te.bind(globalI18n),
  n: globalI18n.n.bind(globalI18n),
});

// Legacy-mode bridge for setup() components. `$t`/`$i18n` are injected on the
// component instance after setup(), so setup() callers use the app-level i18n
// instance registered during boot instead of enabling deprecated composition
// support in vue-i18n legacy mode.
export function useI18n() {
  if (i18nInstance?.global) {
    return bindGlobalI18n(i18nInstance.global);
  }

  const i18n = useVueI18n({ useScope: 'global' });

  return {
    locale: i18n.locale,
    t: i18n.t,
    // vue-i18n 9 composition API has no `tc`; pluralization goes through
    // `t`. None of the current callers use `tc`, this keeps the shape.
    tc: (...args) => i18n.t(...args),
    d: i18n.d,
    te: i18n.te,
    n: i18n.n,
  };
}
